<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 患者干预档案
-->

<template>
  <div class="page-main">
    <div v-if="showTip != -1" class="tip">
      长按分享或保存图片
    </div>
    <div v-if="!url" class="info" id="reportCon">
      <div class="page-content">
        <div class="page-header">
          <div class="header-title">
            <span>{{ patientName }}的干预方案</span>
          </div>
          <div class="header-con">
            您好!根据您的情况制定的干预方案如下(减重过程中根据情况可能会微调)
          </div>
        </div>
        <div class="energy-box">每天摄入能量：<span v-if="cardData.energy" class="energy">{{ cardData.energy }}kcal</span><span
            class="energy" v-else>自定义</span></div>
        <div class="card-list">
          <div class="card-con" v-for="item in cardModules" data-item="item" :key="item">
            <div v-if="cardData[item.key] != null && cardData[item.key] != ''">
              <div class="card-border" :style="{ borderColor: item.color }">
                <div class="card-header">
                  <img class="b-icon" :src="item.icon" />
                  <span>{{ item.title }}</span>
                </div>
                <div v-html=" cardData[item.key] " class="card-text" />
                 
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-else class="img-box">
      <img :src="url" />
    </div>

  </div>
</template>

<script>
// import VConsole from 'vconsole'

// new VConsole()
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import icon_1 from "../assets/intervenePlan/c-icon-1.png"
import icon_2 from "../assets/intervenePlan/c-icon-2.png"
import icon_3 from "../assets/intervenePlan/c-icon-3.png"
import icon_4 from "../assets/intervenePlan/c-icon-4.png"
import icon_5 from "../assets/intervenePlan/c-icon-5.png"

const stageCodeVO={
    1: "启动期",
    2: "过渡期",
    3: "维持期",
}

export default {
  data() {
    return {
      url: '',
      cardData: [],
      stageNameText:'',
      cardModules: [{
        title: '饮食方案',
        key: 'foodPlan',
        color: "#3FDDB4",
        icon: icon_1
      }, {
        title: '运动方案',
        key: 'sportPlan',
        color: "#5EC9EF",
        icon: icon_2
      }, {
        title: '检测建议',
        key: 'checkPlan',
        color: "#F86E6E",
        icon: icon_3
      }, {
        title: '沟通建议',
        key: 'communicatePlan',
        color: "#9982FC",
        icon: icon_4
      }, {
        title: '注意事项',
        key: 'precautions',
        color: "#FBB13D",
        icon: icon_5
      }]
    };
  },
  mounted() {
    this.id = getQueryString('id');
    this.showTip = getQueryString('showTip');
    this.patientName = decodeURI(getQueryString('patientName', true));

    // this.id = "1894253833146880002";
    // this.patientName = "111";

    document.title = `干预方案`;

    window.alert=function(){};
    window.confirm=function(){};
    window.prompt=function(){};
    
    this.getList()
    this.getSignature();
  },

  methods: {
    getSignature() {
      ajax
        .Post({
          url: '/api/third/wx/getJsSdkAuthSignature',
          data: { appId: 'wxf09a4a37c6cbea9c', type: 1, url: window.location.href }
        }).then(({ data: { data } }) => {
          window.wx.config({
            debug: true,
            appId: 'wxf09a4a37c6cbea9c',
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['miniProgram']
          });
        })
    },
    processTextContent (text) {
      return text
          .split('\n')
          .map((line, index, arr) => {
            const isLastLine = index === arr.length - 1;
            return line + (isLastLine ? '' : '<br/>');
          })
          .join('');
    },
    getList() {
      ajax
        .Post({
          url: '/api/loss/lossInterventionPlan/selectPatientPlan',
          data: { id: this.id }
        }).then(({ data: { success, data } }) => {
          if (success) {
            for (const key in data) {
              data[key]=data[key]&&this.processTextContent(data[key])
            }
            this.cardData = data;
            this.stageNameText=stageCodeVO[data.stageName]
            setTimeout(() => {
              this.saveImg()
            }, 500);
          }
        })
    },
    saveImg() {
      htmlToPDF('reportCon').then(url => {
        if(url.includes('data:image/jpeg;base64,')){ 
          console.log("success")
          this.url = url
        }else{
          console.log("error")
        }
        
      });
    },

  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-content {
  /*height: 100vh;*/
  /*overflow: auto;*/
  background-color: #fff;
}
.content textarea{
  width:100%;
  height:100%;
  
}
.page-header {
  width: 100%;
  height: auto;
  padding: 16px 24px;
  background: #FBB13D;
}

.page-header .header-title {
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.page-header .header-title span {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
}

.energy-box {
  font-size: 14px;
  color: #000000;
  height: 44px;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 16px 0 0 16px;

}

.energy-box .energy {
  font-weight: 500;
  font-size: 20px;
  color: #FBB13D;
}

.page-header .header-con {
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: justify;
  margin-bottom: 18px;
}

.card-list {
  width: 100%;
  height: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-list .card-con .card-border {
  width: 100%;
  /* min-height: 160px; */
  height: auto;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #3FDDB4;
  padding: 16px;
}

.menu-icon {
  width: 18px;
  height: 16px;
}

.card-list .card-con .card-border .card-header {
  display: flex;
  height: 20px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
}

.card-list .card-con .card-border .card-header span {
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.card-text {
  width: 100%;
  height: auto;
  line-height: 20px;
  color: #333;
  background: #FFF8F3;
  border-radius: 10px;
  padding: 12px;
}

.b-icon {
  width: 20px;
  height: 20px;
}

.a-icon {
  width: 14px;
  height: 14px;
}

.tip {
  color: #777;
  color: #FE5B59;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  padding-bottom: 1rem;
  padding-top: 10px;
  background-color: #F6F7F8;
}

.img-box {
  width: 100%;
  height: auto;
}

.img-box img {
  width: 100%;
  height: auto;
}
</style>
